<header class="page-header">
  <div class="page-header__content">
    <div class="page-header__left">
      @if (hasBackAction()) {
        <button
          type="button"
          class="page-header__back"
          (click)="onBackClick()"
        >
          <i class="pi pi-chevron-left" aria-hidden="true"></i>
        </button>
      }

      <div class="page-header__branding">
        @if (config()?.logoUrl; as logoUrl) {
          <img
            [src]="logoUrl"
            [alt]="title()"
            class="page-header__logo"
          />
        } @else {
          <div
            class="page-header__icon-wrapper"
            [style.background]="config()?.iconBg || 'var(--p-primary-100)'"
          >
            <i
              [class]="headerIconClass()"
              [style.color]="config()?.iconColor || null"
              aria-hidden="true"
            ></i>
          </div>
        }

        <div class="page-header__info">
          <div class="page-header__title-container">
            <h1 class="page-header__title">{{ title() }}</h1>

            @if (config()?.showGovBadge) {
              <span
                class="gov-badge"
                pTooltip="Synchronizacja z GOV włączona"
                tooltipPosition="bottom"
              >
                GOV
              </span>
            }
          </div>

          @if (config()?.subtitle; as subtitle) {
            <p class="page-header__subtitle">
              <i class="pi pi-map-marker" aria-hidden="true"></i>
              {{ subtitle }}
            </p>
          }
        </div>
      </div>
    </div>

    @if (actions().length > 0) {
      <div class="page-header__actions">
        @for (action of actions(); track action.id) {
          <p-button
            [label]="action.label"
            [icon]="action.icon || undefined"
            [severity]="action.severity || 'primary'"
            [outlined]="isActionOutlined(action)"
            [disabled]="action.disabled || false"
            [pTooltip]="action.tooltip || undefined"
            tooltipPosition="bottom"
            (onClick)="action.handler()"
          />
        }
      </div>
    }
  </div>
</header>
